import { MessageCircle, Phone, Mail, Instagram, Music2, Ghost, ArrowUpRight } from "lucide-react";
import { WHATSAPP_URL } from "../lib/whatsapp";
import {
  PHONE_DISPLAY,
  PHONE_TEL,
  EMAIL,
  EMAIL_MAILTO,
  INSTAGRAM_HANDLE,
  INSTAGRAM_URL,
  TIKTOK_HANDLE,
  TIKTOK_URL,
  SNAPCHAT_HANDLE,
  SNAPCHAT_URL,
} from "../lib/contact";

const cards = [
  {
    key: "phone",
    label: "Phone",
    value: PHONE_DISPLAY,
    support: "Prefer to talk it through? Give us a call.",
    href: PHONE_TEL,
    icon: Phone,
    action: "Call Now",
  },
  {
    key: "email",
    label: "Email",
    value: EMAIL,
    support: "Send us the details and we'll reply as soon as we can.",
    href: EMAIL_MAILTO,
    icon: Mail,
    action: "Send Email",
  },
  {
    key: "instagram",
    label: "Instagram",
    value: INSTAGRAM_HANDLE,
    support: "See our latest repairs and driving test wins.",
    href: INSTAGRAM_URL,
    icon: Instagram,
    action: "Follow",
    external: true,
  },
  {
    key: "tiktok",
    label: "TikTok",
    value: TIKTOK_HANDLE,
    support: "Behind-the-scenes bodyshop and claims content.",
    href: TIKTOK_URL,
    icon: Music2,
    action: "Follow",
    external: true,
  },
  {
    key: "snapchat",
    label: "Snapchat",
    value: SNAPCHAT_HANDLE,
    support: "Add us for quick updates and stories.",
    href: SNAPCHAT_URL,
    icon: Ghost,
    action: "Add Us",
    external: true,
  },
];

export const ContactCards = () => (
  <div data-testid="contact-cards" className="space-y-4">
    {/* WhatsApp — most prominent */}
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="contact-card-whatsapp"
      className="group flex flex-col gap-5 bg-[#c9a24b] p-6 text-[#0a0a09] transition-colors duration-200 hover:bg-[#e6c87a] sm:flex-row sm:items-center sm:justify-between sm:p-8"
    >
      <div className="flex items-center gap-4">
        <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#0a0a09]/10">
          <MessageCircle size={26} />
        </span>
        <div>
          <p className="text-lg font-bold uppercase tracking-[0.14em]">WhatsApp</p>
          <p className="mt-1 text-sm font-semibold">{PHONE_DISPLAY}</p>
          <p className="mt-1 text-sm text-[#0a0a09]/75">
            The quickest way to reach us — message us anytime.
          </p>
        </div>
      </div>
      <span className="inline-flex items-center justify-center gap-2 border-2 border-[#0a0a09] px-6 py-3 text-xs font-bold uppercase tracking-[0.16em] transition-colors duration-200 group-hover:bg-[#0a0a09] group-hover:text-[#e6c87a]">
        Message Us
        <ArrowUpRight size={15} />
      </span>
    </a>

    {/* Remaining channels */}
    <div className="grid gap-4 sm:grid-cols-2">
      {cards.map(({ key, label, value, support, href, icon: Icon, action, external }) => (
        <a
          key={key}
          href={href}
          target={external ? "_blank" : undefined}
          rel={external ? "noopener noreferrer" : undefined}
          data-testid={`contact-card-${key}`}
          className="group flex flex-col justify-between border border-[rgba(201,162,75,0.28)] bg-[#111110] p-6 transition-colors duration-200 hover:border-[#c9a24b]"
        >
          <div>
            <div className="flex items-center gap-4">
              <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center border border-[rgba(201,162,75,0.4)] text-[#c9a24b] transition-colors duration-200 group-hover:bg-[#c9a24b] group-hover:text-[#0a0a09]">
                <Icon size={20} />
              </span>
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#e6c87a]">
                  {label}
                </p>
                <p className="mt-0.5 text-sm text-[#f2ede3]">{value}</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-[#a09a8c]">{support}</p>
          </div>
          <span className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-[#c9a24b] transition-colors duration-200 group-hover:text-[#e6c87a]">
            {action}
            <ArrowUpRight size={14} />
          </span>
        </a>
      ))}
    </div>
  </div>
);
